// Hook للتحقّق من صلاحية للمستخدم الحالي — يستعمل /api/permissions/me مع كاش
import { useEffect, useState } from "react";
import { getMyPerms } from "../api/permissions";

let CACHE = null;
let LOADING = null;

async function load() {
  if (CACHE) return CACHE;
  if (LOADING) return LOADING;
  LOADING = getMyPerms()
    .then((d) => {
      CACHE = { perms: new Set(d.permissions || []), isAdmin: !!d.is_admin };
      return CACHE;
    })
    .catch(() => {
      CACHE = { perms: new Set(), isAdmin: false };
      return CACHE;
    });
  return LOADING;
}

export function clearPermsCache() {
  CACHE = null;
  LOADING = null;
}

export function useCan(key) {
  const [ready, setReady] = useState(!!CACHE);
  useEffect(() => {
    if (!CACHE) load().then(() => setReady(true));
  }, []);
  if (!ready || !CACHE) return { can: true, ready: false };
  if (CACHE.isAdmin) return { can: true, ready: true };
  const keys = Array.isArray(key) ? key : [key];
  return { can: keys.some((k) => CACHE.perms.has(k)), ready: true };
}
